import { connect } from 'react-redux';
import RateReview from './rate_review';
import { sendOrderReview } from '../../actions/order_details';

const mapStateToProps = ({
  chat, voipChat, orderDetails
}, { orderId, advisorId }) => {
  const sessionData = chat?.orderId ? chat : { ...voipChat, ...voipChat?.order };
  return {
    ...sessionData,
    orderId,
    advisorId,
    loading: orderDetails.loading
  };
};

export default connect(
  mapStateToProps,
  { sendOrderReview }
)(RateReview);
